import { render, staticRenderFns } from "./BenefitInformations.vue?vue&type=template&id=7e204150"
import script from "./BenefitInformations.vue?vue&type=script&lang=js"
export * from "./BenefitInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports